export default {
	install(Vue, options) {
		Vue.prototype.$textToSpeech = function(word, url1, url2, voice) {
			let currentUrl = ''
			let currentVoice = "Matthew"

			if(voice===1){
				currentUrl = this.url1
			}
			else{
				currentUrl = this.url2
				currentVoice = "Salli"
			}

			if(currentUrl == ''){
				// Initialize the Amazon Cognito credentials provider
				AWS.config.region = 'eu-west-3';
				AWS.config.credentials = new AWS.CognitoIdentityCredentials({IdentityPoolId: 'eu-west-3:acfb193c-b37d-4ee9-bcbd-209283d4a2ec'});

				var speechParams = {
					OutputFormat: "mp3",
					SampleRate: "22050",
					Text: word,
					TextType: "text",
					VoiceId: currentVoice
				};
				var polly = new AWS.Polly({apiVersion: '2016-06-10'});
				var signer = new AWS.Polly.Presigner(speechParams, polly)

				// Create presigned URL of synthesized speech file
				signer.getSynthesizeSpeechUrl(speechParams, (error, url) => {
					if (!error) {
						if(this.voice===1) {
							this.url1 = url
							this.voice = 2
						}
						else{
							this.url2 = url
							this.voice = 1
						}
						new Audio(url).play();
					}
					else {
						console.log(error)
					}
				})
			}
			else{
				new Audio(currentUrl).play();
				if(this.voice===1){
					this.voice = 2
				}
				else{
					this.voice = 1
				}
			}
		}
	}
}